module.exports = __webpack_public_path__ + "static/testi3-afc443cbf9a0175b2e4d1986869e7712.jpg";